import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { register } from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

let updateNeeded = undefined;

const updateServiceWorker = ({ waiting }) => {
  const registrationWaiting = waiting;
  if (registrationWaiting) {
    registrationWaiting.postMessage({ type: "SKIP_WAITING" });
    registrationWaiting.addEventListener("statechange", (e) => {
      if (e.target.state === "activated") {
        window.location.reload();
      }
    });
  }
};

const UpdateBanner = () => {
  const [update, setUpdate] = useState(!!updateNeeded);

  useEffect(() => {
    let tries = 0;
    const checkUpdateInterval = setInterval(() => {
      tries = tries + 1;
      if (updateNeeded) setUpdate(true);
      if (tries >= 5) clearInterval(checkUpdateInterval);
    }, 3000);
    return () => {
      clearInterval(checkUpdateInterval);
    };
  }, []);

  return (
    update && (
      <div
        className="text update-banner"
        onClick={() => updateServiceWorker(updateNeeded)}
      >
        update!
      </div>
    )
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UpdateBanner />
    <App />
  </React.StrictMode>
);

document.oncontextmenu = document.body.oncontextmenu = function () {
  return false;
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
register({
  onSuccess: () => console.log("success"),
  onUpdate: (reg) => (updateNeeded = reg || null),
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
